import React, { useState } from 'react';
import { LeftOutlined } from '@ant-design/icons';
import styled from 'styled-components';

const StyledContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TemplateDrawerMenu = ({ templateDrawer }) => {
  const [collapsed, setCollapsed] = useState(false);
  return (
    <div className="template-drawer-menu">
      <StyledContainer
        onClick={() => {
          setCollapsed(!collapsed);
        }}
        onKeyDown={() => {}}
      >
        <LeftOutlined style={{ color: '#FFFFFF' }} />
      </StyledContainer>
      {templateDrawer(collapsed, setCollapsed)}
    </div>
  );
};

export default TemplateDrawerMenu;
